import {
  PRODUCT_LIST_FAILED,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_INVALID_REQUEST,
  PRODUCT_LIST_NOT_FOUND,
  LOADING_PRODUCT_LIST,
  RESET_PRODUCT_LIST,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  products: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_PRODUCT_LIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
      };

    case PRODUCT_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
      };
    case PRODUCT_LIST_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
      };

    case PRODUCT_LIST_SUCCESS: {
      // const { ccId, data } = action.payload;

      // const productCategory =
      //   (ccId === "1" && "shopping") ||
      //   (ccId === "2" && "travel") ||
      //   (ccId === "3" && "foodAndBeverage") ||
      //   (ccId === "4" && "beautyAndSpa") ||
      //   (ccId === "5" && "healthAndFitness") ||
      //   (ccId === "6" && "entertainment");

      // const newProducts = { ...state.products, [productCategory]: data };

      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        products: action.payload.data,
      };
    }

    case PRODUCT_LIST_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
      };

    case RESET_PRODUCT_LIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: false,
      };

    default:
      return state;
  }
};
